import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=54bd7412&scoped=true"
import script from "./Debug.vue?vue&type=script&lang=ts"
export * from "./Debug.vue?vue&type=script&lang=ts"
import style0 from "./Debug.vue?vue&type=style&index=0&id=54bd7412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd7412",
  null
  
)

export default component.exports